import { lang } from 'app/config/language'
import { observer } from 'mobx-react-lite'
import { ErrorPage } from 'page/base/ErrorPage'
import { LoadingPage } from 'page/base/LoadingPage'
import { store, TryOnPageStore } from 'page/tryon/store/TryOnPageStore'
import { View } from 'page/tryon/View'
import { useEffect, useMemo } from 'react'
import { route } from 'store/route'
import css from './TryOnPage.module.scss'

export const TryOnPage = observer(() => {
  const inference_id = route.unit(1)
  useMemo(() => store.it = new TryOnPageStore(inference_id), [inference_id])
  const { error, ready, product } = store.it

  useEffect(() => {
    if (!product) return

    const primary = product.color?.primary || undefined
    const text = product.color?.text || undefined

    document.body.classList.add(css.vars)
    document.body.style.setProperty('--ui-primary-color', primary || null)
    document.body.style.setProperty('--ui-text-color', text || null)

    return () => {
      document.body.classList.remove(css.vars)
      document.body.style.setProperty('--ui-primary-color', null)
      document.body.style.setProperty('--ui-text-color', null)
      document.body.style.setProperty('--max-width', null)
      document.body.style.setProperty('--header-height', null)
      document.body.style.setProperty('--footer', null)
    }
  }, [product])

  if (error) return <ErrorPage text={error} />
  if (!lang.ready || !ready) return <LoadingPage />

  return <View />
})
